import '@/utils/suppressProdLogs'
import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import './index.css'
import './styles/book-animations.css'
import { AuthProvider } from './context/AuthContext'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

// --- ADDED: Debug Logging for Environment Variables ---
// console.log('[DEBUG] import.meta.env:', import.meta.env); // <<< REMOVED/COMMENTED
// console.log('[DEBUG] VITE_BACKEND_API_URL:', import.meta.env.VITE_BACKEND_API_URL); // <<< REMOVED/COMMENTED
// console.log('[DEBUG] VITE_SUPABASE_URL:', import.meta.env.VITE_SUPABASE_URL); // <<< REMOVED/COMMENTED
// console.log('[DEBUG] VITE_SUPABASE_ANON_KEY:', import.meta.env.VITE_SUPABASE_ANON_KEY); // <<< REMOVED/COMMENTED
// --- END: Debug Logging --- 

// Debug helpers for the console
const debugHighlights = {
  analyze: () => {
    // Get all highlights in the document
    const highlights = document.querySelectorAll('.highlighted-text');
    console.log(`Found ${highlights.length} highlights`);
  
    // Log the first few highlights
    if (highlights.length > 0) {
      for (let i = 0; i < Math.min(5, highlights.length); i++) {
        const highlight = highlights[i] as HTMLElement;
        const styles = window.getComputedStyle(highlight);
        
        console.log(`Highlight ${i+1}:`, {
          element: highlight,
          inlineStyle: highlight.getAttribute('style'),
          computedStyles: {
            backgroundColor: styles.backgroundColor,
            background: styles.background,
            backgroundImage: styles.backgroundImage,
            boxShadow: styles.boxShadow,
            display: styles.display,
            position: styles.position
          },
          cssText: highlight.style.cssText
        });
      }
    }
  },
  
  forceBackgrounds: () => {
    // Apply direct background colors to all highlights
    const highlights = document.querySelectorAll('.highlighted-text');
    highlights.forEach(h => {
      // Type assertion
      const element = h as HTMLElement;
      element.style.backgroundColor = 'rgba(128, 128, 128, 0.2)';
      element.style.background = 'rgba(128, 128, 128, 0.2)';
      element.style.backgroundImage = 'none';
    });
    
    console.log(`Applied force backgrounds to ${highlights.length} highlights`);
  }
};

// Make debug functions available in the console
(window as any).debugHighlights = debugHighlights;

// Create a client for react-query
// Check if this already exists elsewhere in the project setup
const queryClient = new QueryClient();

// Ensure root element exists
const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error('Failed to find the root element');
}

createRoot(rootElement).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <App />
      </AuthProvider>
    </QueryClientProvider>
  </React.StrictMode>
);
